import { createContext, useContext, useState } from "react";

const GerenciamentoContext = createContext();

export function GerenciamentoProvider({ children }) {
  const [modulo, setModulo] = useState(null);
  const [acao, setAcao] = useState("pesquisar");
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [retorno, setRetorno] = useState(null);

  // Sidebar
  const selecionarModulo = (nomeModulo) => {
    setModulo(nomeModulo);
    setAcao("pesquisar");
    setItemSelecionado(null);
    setRetorno(null);
  };

  const selecionarAcao = (novaAcao) => {
    setAcao(novaAcao);
  };

  // Navbar
  const novoRegistro = () => {
    setAcao("novo");
    setItemSelecionado(null);
  };

  const alterarRegistro = (item = null) => {
    const itemFinal = item || itemSelecionado;
    if (!itemFinal) return;

    setItemSelecionado(itemFinal);
    setAcao("alterar");
  };

  // Grid
  const selecionarItem = (item) => {
    setItemSelecionado(item);
  };

  const fecharForm = () => {
    setAcao("pesquisar");
    setItemSelecionado(null);
  };

  return (
    <GerenciamentoContext.Provider
      value={{
        modulo,
        acao,
        itemSelecionado,
        selecionarModulo,
        selecionarAcao,
        selecionarItem,
        novoRegistro,
        alterarRegistro,
        fecharForm,
        retorno,
        setRetorno,
      }}
    >
      {children}
    </GerenciamentoContext.Provider>
  );
}

export function useGerenciamento() {
  return useContext(GerenciamentoContext);
}
